'use client';

import type { CtaType } from '@ria-client/segment/Analytics/types';
import { LinkType } from '@ria-client/segment/enums';
import type { AnalyticsType } from '@ria-client/segment/types';
import { EntityPlacementCtaTypeEnum } from '@ria-client/supergraph/marketplace/enums';
import type { ImageType } from '@ria-client/supergraph/roundup/types';
import { TrackedLink } from '@ria-client/tw-shared-ui';
import Image from 'next/image';

export interface CtaImageProps {
  analyticsPayload: AnalyticsType;
  image?: ImageType;
  cta?: CtaType;
  displayName?: string;
}

export function CtaImage({ analyticsPayload, cta, displayName, image }: CtaImageProps) {
  if (!image?.source) return null;

  const imageComponent = (
    <Image
      alt={image.alt || displayName || ''}
      className="h-full w-full"
      height={200}
      src={image.source}
      width={200}
    />
  );

  return (
    <div className="w-full">
      {cta ? (
        <TrackedLink
          analyticsPayload={analyticsPayload}
          cta={{ ...cta, type: EntityPlacementCtaTypeEnum.ProductImage }}
          linkType={LinkType.PRODUCT_IMAGE}
          monetizable={analyticsPayload.monetizable}
        >
          {imageComponent}
        </TrackedLink>
      ) : (
        imageComponent
      )}
    </div>
  );
}
